export const orgOnboarding = 'org-config';
export const performance = 'performance-config';
export const recruiting = 'recruiting-config';
export const employee = 'employee-config';
export const workplace = 'workplace-config';
export const payroll = 'payroll-config';
export const claims = 'claims-config';

export const getSysConfigTabs = (permissions) => {
  return [
    {
      name: orgOnboarding,
      path: `/sys-config/${orgOnboarding}`,
      label: 'Org Onboarding Config',
      title: 'Org Onboarding Config',
      show: permissions?.[orgOnboarding]?.allowView,
    },
    {
      name: employee,
      path: `/sys-config/${employee}`,
      label: 'User Onboarding Config',
      title: 'User Onboarding Config',
      show: permissions?.[employee]?.allowView,
    },
    {
      name: performance,
      path: `/sys-config/${performance}`,
      label: 'Performance Config',
      title: 'Performance Config',
      show: permissions?.[performance]?.allowView,
    },
    {
      name: recruiting,
      path: `/sys-config/${recruiting}`,
      label: 'Recruiting Config',
      title: 'Recruiting Config',
      show: permissions?.[recruiting]?.allowView,
    },
    {
      name: workplace,
      path: `/sys-config/${workplace}`,
      label: 'Workplace Config',
      title: 'Workplace Config',
      show: permissions?.[workplace]?.allowView,
    },
    {
      name: payroll,
      path: `/sys-config/${payroll}`,
      label: 'Payroll Config',
      title: 'Payroll Config',
      show: permissions?.[payroll]?.allowView,
    },
    // {
    //   name: claims,
    //   path: `/sys-config/${claims}`,
    //   label: 'Claims Config',
    //   title: 'Claims Config',
    //   show: permissions?.[claims]?.allowView,
    // },
  ];
};
